import { render } from "./BetsumaProfile.vue?vue&type=template&id=9bd23880&scoped=true&ts=true"
import script from "./BetsumaProfile.vue?vue&type=script&lang=ts"
export * from "./BetsumaProfile.vue?vue&type=script&lang=ts"

import "./BetsumaProfile.vue?vue&type=style&index=0&id=9bd23880&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1111083459/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bd23880"]])

export default __exports__